import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import '../index.less'

@Component({
  components: {
  }
})
export default class RulesContent extends Vue {
  @Prop({ default: () => []}) readonly dataSource: Array<any>
  @Prop({ default: ""}) readonly selectRowKey: String
  @Prop({ default: false}) readonly loading: Boolean
  
  get columns() {
    return [
      {
        title: this.$t('page_system_coding_rules_name'),
        dataIndex: 'name',
        key: 'name',
        width:150,
        ellipsis: true,
      },
      {
        title: this.$t('page_system_coding_rules_application_object'),
        dataIndex: 'applicationObject',
        key: 'applicationObject',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('remark'),
        dataIndex: 'remark',
        key: 'remark',
        ellipsis: true
      },
    ]
  };

  cilentHeight = 130

  updated(){
    const div = document.querySelector('#rulesContent-table')
    if(div !== null){
      this.cilentHeight = div.clientHeight - 60
    }
  };

  rowClick(record) {
    return {
      on: {
        click: (event) => {
          this.$emit('rowClick',record.id)
        },
      },
    }
  }

  render(){
    return(
      <div>
        <ml-table
          rowKey="id"
          defaultExpandAllRows={true}
          canChangeColWidth={true}
          loading={this.loading}
          dataSource={this.dataSource}
          columns={this.columns}
          custom-row={this.rowClick}
          selectRowKey={this.selectRowKey}
          scroll={{y: this.cilentHeight}}
        >
        </ml-table>
      </div>
    )
  }
}